import { reactive } from 'vue'
import { useI18n } from 'vue-i18n'

const state = reactive({
  visible: false,
  title: '',
  message: '',
  acceptLabel: '',
  rejectLabel: '',
  acceptSeverity: 'secondary',
  rejectSeverity: 'primary',
  _resolve: null,
})

function finish(result) {
  const resolve = state._resolve
  if (!resolve) {
    return
  }
  state._resolve = null
  state.visible = false
  resolve(result)
}

export function useAppConfirmState() {
  return state
}

export function useAppConfirm() {
  const { t } = useI18n()

  function confirm({
    message,
    title = t('common.confirm'),
    acceptLabel = t('common.confirm'),
    rejectLabel = t('common.cancel'),
    acceptSeverity = 'secondary',
    rejectSeverity = 'primary',
  } = {}) {
    return new Promise((resolve) => {
      state.title = title
      state.message = message ?? ''
      state.acceptLabel = acceptLabel
      state.rejectLabel = rejectLabel
      state.acceptSeverity = acceptSeverity
      state.rejectSeverity = rejectSeverity
      state._resolve = resolve
      state.visible = true
    })
  }

  function accept() {
    finish(true)
  }

  function reject() {
    finish(false)
  }

  return {
    confirm,
    accept,
    reject,
  }
}
